<template lang="pug">
.content()
  div()
    PageC
</template>
<script>
import config from '@/const/config';
import GalileoAb from '@hb/ab-sdk';
import { env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { isPreRender, getTokenAndLocation } from '../../utils';
import PageB from './page-b';
import PageC from './page-c/index';
import { ParamsUtil } from '../../utils/params';

export default {
  components: {
    PageB,
    PageC,
  },
  data() {
    return {
      page: null,
      show: null,
    };
  },
  created() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      // eslint-disable-next-line no-useless-return
      return;
    }
    this.show = isPreRender();
    this.initGalileoAb();
  },
  methods: {
    async initGalileoAb() {
      // eslint-disable-next-line prefer-const
      let { cityCode, userGuid } = await getTokenAndLocation();
      if (env.isWechatMini || env.isAlipayBrowser || env.isAliMP) {
        userGuid = ParamsUtil.getParams(window.location.href).userGuid;
        // eslint-disable-next-line no-console
        console.log('userGuid', userGuid);
      }
      const galileoAb = new GalileoAb(
        {
          env: config.env,
          version: '5.81.1',
          cityCode, // 非必填
          appName: 'hellobike',
          systemCode: 63, // 固定Ae3
        },
        UBT, // 初始化后的UBT对象
      );
      await galileoAb.getAbSingleTestResult({
        experimentId: '202205181154022843', // 实验id
        cityCode, // 非必填
        timeout: 400, // 非必填，默认400毫秒
        defaultVersionId: '202205181154023871', // 兜底版本
        userGuid,
      })
        .then((res) => {
          const { versionArgs } = res;
          if (versionArgs) {
            this.page = versionArgs.ver;
          } else {
            this.page = 'false';
          }
        })
        .catch();
    },

  },
};
</script>
<style lang="less" scoped>
.content {
  min-height: 100%;
  position: relative;
}
</style>
